import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { IMAGE_URL, REACT_APP_API_PORT } from '../Api';
import axios from 'axios';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router';
import { getDecryptedData, storeEncryptedData } from '../config/crypto';
import Alert from '../components/Alert';
import { useGoogleLogin } from '@react-oauth/google';

import CountdownTimer from '../components/CountdownTimer';

const GoogleLoginButton = ({ location, apiIsLoading, handleGoogleLogin }) => {
    const navigate = useNavigate();

    const [alertBox, setAlertBox] = useState(false)
    const [alert, setAlert] = useState({
        message: "",
        color: ""
    })
    const showAlert = (message, color) => {
        setAlert({ message: message, color: color })
    }

       const [imgLoaded, setImgLoaded] = useState(false);
    


    const login = useGoogleLogin({
        onSuccess: async (credentialResponse) => {
            try {
                // Fetch user info from Google
                const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: {
                        Authorization: `Bearer ${credentialResponse.access_token}`,
                    },
                });

                const user = res.data;
                if (user) {
                    handleGoogleLogin(user);
                }

                console.log('✅ User Info:', user);


            } catch (error) {
                console.error('❌ Failed to fetch user info:', error);
            }

        },
        onError: () => {
            console.error('Login Failed');
        },
    });



    return (
        <>
            <Alert alert={alert} alertBox={alertBox} setAlertBox={setAlertBox} />

            <button type='button' onClick={() => login()} className="bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition-all duration-300 shadow-lg px-4 py-2 rounded text-white text-[15px] font-bold uppercase flex items-center justify-center lg:px-10 lg:py-3 w-full">
                <img src="/images/google.png" alt="Google logo" width={26} height={26} className="mr-2 bg-[#ffffff] rounded-full p-1" />
                Sign in with Google
            </button>

        </>
    );
};
const UnlockPromptsPopup = ({ onClose }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const auth = getDecryptedData("token");

  if (!data) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-md flex justify-center items-center z-50 px-2">

      <div className="relative w-full max-w-xl rounded-2xl bg-[#1c1c1e] shadow-2xl">

        {/* ❌ CLOSE */}
       <button
  onClick={onClose}
  className="
    absolute top-3 right-3 
    z-50
    bg-black/70 hover:bg-black
    text-white 
    w-9 h-9 
    rounded-full 
    flex items-center justify-center
    text-xl font-bold
    shadow-lg
    transition
  "
  aria-label="Close popup"
>
  ×
</button>


        <div className="relative w-full h-48 sm:h-80 overflow-hidden rounded-t-2xl">
  <img
    src="https://live.nextfutureai.com/images/learn/image2.jpeg"
    alt="Special Offer"
    onError={(e) => {
      e.target.src = "/images/placeholder-offer.png";
    }}
    className="w-full h-full object-cover"
  />
</div>



        {/* CONTENT */}
        <div className="p-6 text-white text-center">
          <h1 className="flex justify-center gap-2 text-2xl font-bold mb-3">
            Unlock 2000+ Prompts
          </h1>

           <div className="text-center text-sm sm:text-base text-gray-300 dark:text-gray-300 mb-3 px-1 sm:px-3">
  Create a free account to continue exploring AI-generated images and prompts
</div>


          {auth ? (
            <button
              onClick={() => {
                onClose();
                navigate("/coupons");
              }}
              className="w-full py-3 rounded-lg bg-gradient-to-r from-pink-500 to-purple-600"
            >
              Get Coupon
            </button>
          ) : (
            <GoogleLoginButton handleGoogleLogin={() => {}} />
          )}
        </div>
      </div>
    </div>
  );
};


export default UnlockPromptsPopup;
